import { useParams } from 'react-router-dom';

import { Project } from '../app/entities/project';

export const useCurrentProject = () => {
  const { projectId } = useParams() as { spaceId: string; projectId: string };

  return Project.getOne(projectId);
};
